export default __webpack_public_path__ + "static/media/people.92351f65.svg";